import { Channel, Topic } from "../constants/index.js";
import { MessageBrokerUtils } from "../utils/index.js";
import { useCallback } from "react";
import { performAction } from "../utils/actionUtils.js";
import { UserContextSelectors } from "../redux/selectors/index.js";
import { useSelector } from "react-redux";
import { MigrationUtils } from "../utils/migrationUtils.js";
import { useFeature } from "./useFeature.js";
import { AppFeatures } from "../constants/featureFlags.js";

export const useAccountCommunicationHandlers = () => {
  const openMyAccount = useCallback(data => {
    MessageBrokerUtils.publish({
      channel: Channel.PLAYER,
      topic: Topic.CTA_MyAccount_Open,
      headers: { publisher: "UAA" },
      data: data
    });
  }, []);

  const openLogin = useCallback(() => {
    MessageBrokerUtils.publish({
      channel: Channel.PLAYER,
      topic: Topic.loginCompletion,
      headers: { publisher: "UAA" }
    });
  }, []);

  const useOpenRegister = () => {
    const brandId = useSelector(UserContextSelectors.brandId);
    const isNative = useSelector(UserContextSelectors.isNative);
    const isEagleMigrationStarted = useFeature(AppFeatures.EAGLE_MIGRATION);
    const isIOS = useSelector(UserContextSelectors.isIOS);

    return useCallback(() => {
      // For 888Ro brand, registration is handled externaly via Eagle
      if (
        isEagleMigrationStarted &&
        MigrationUtils.isSportRoMigrationOngoing()
      ) {
        MigrationUtils.handleOpenRegistration(isNative, isIOS);
        return;
      }

      performAction("register");
      // eslint-disable-next-line
    }, [brandId, isNative, isEagleMigrationStarted, isIOS]);
  };

  const openChallengesOrPromotions = useCallback(() => {
    // the logic to determine promotions or challenges is implemented in the action itself
    performAction("openPromotions");
  }, []);

  return {
    openMyAccount,
    openLogin,
    useOpenRegister,
    openChallengesOrPromotions
  };
};
